import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Cache } from "aws-amplify";
import { Row, Col, Table, Button, Form } from "react-bootstrap";
import {
  fetchPlatforms,
  deletePlatform,
  filterPlatforms,
  SET_PLATFORMS_PAGINATION,
  RESET_PLATFORMS_PAGINATION,
} from "../../../store/actions/platforms/platformActions";
import { ConfirmDialog } from "../../../common/Utilities";
import {
  togglePrompt,
  resetPagination,
} from "../../../store/actions/commonActions";
import {
  PORTAL_ADMIN,
  FINANCE_APPROVER,
} from "../../../store/actions/users/usersActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";

import PageTitle from "../../../common/PageTitle";
import ListPagination from "../../../common/ListPagination";

class Platforms extends Component {
  constructor(props) {
    super(props);
    this.platform = {};
  }

  componentDidMount() {
    const roleId = Cache.getItem("roleId");
    if (roleId === PORTAL_ADMIN || roleId === FINANCE_APPROVER) {
      this.props.resetPagination(RESET_PLATFORMS_PAGINATION);
      this.props.fetchPlatforms();
    } else {
      this.props.history.push("/dashboard");
    }
  }

  filterPlatforms = () => {
    return (
      <Form.Control
        size="xl"
        type="search"
        placeholder="Filter Groups"
        onChange={(e) => {
          const filter = e.target.value;
          this.props.filterPlatforms(filter);
        }}
      />
    );
  };

  getFilteredPlatforms = (platforms) => {
    if (!platforms) {
      return null;
    }

    return platforms.filter((platform) => {
      const platformName = platform.platform_name || "";
      const chargeability = platform.chargeability || "";

      const platformData = [platformName, chargeability]
        .join(" ")
        .toLowerCase();

      const platformFilter = this.props.platforms.platformFilter;

      if (
        !platformFilter ||
        platformData.includes(platformFilter.toLowerCase())
      ) {
        return platform;
      }
      return null;
    });
  };

  renderPlatforms = () => {
    let platforms = this.getFilteredPlatforms(this.props.platforms.platforms);

    if (platforms) {
      //if the user tries to search and no matches the filter
      if (this.props.platforms.platformFilter && !platforms.length) {
        platforms = null;
      } else {
        let min = this.props.platforms.min;
        let max = this.props.platforms.max;

        if (!this.props.platforms.platformFilter) {
          platforms = platforms.slice(min - 1, max);
        }
      }
    }

    let platformList = [];

    if (platforms) {
      platformList = platforms.length ? (
        platforms.map((platform, key) => {
          return (
            <tr key={key}>
              <td>
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.history.push(
                      "/settings/platforms/view?id=" + platform.id
                    );
                  }}
                >
                  {platform.platform_name}
                </Link>
              </td>
              <td>
                <div className="float-right tbl-funcs align-items-center">
                  <Button
                    size="sm"
                    className="btn-primary"
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.history.push(
                        "/settings/platforms/update?id=" + platform.id
                      );
                    }}
                  >
                    <FontAwesomeIcon icon={faPen} /> Edit
                  </Button>
                  <FontAwesomeIcon
                    icon={faTrash}
                    onClick={() => {
                      this.platform = platform;
                      this.props.togglePrompt(true);
                    }}
                    className="mx-1 hover-pointer"
                  />
                </div>
              </td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan={2}>Loading...</td>
        </tr>
      );
    } else {
      platformList = (
        <tr>
          <td colSpan={2}>
            <p className="text-danger">No groups found.</p>
          </td>
        </tr>
      );
    }

    return platformList;
  };

  promptModal = () => {
    let modalTitle = "";
    let modalBody = "";

    modalTitle = "Delete Platform";
    modalBody = "Are you sure you want to delete this platform?";

    const onHideFunction = () => {
      this.props.togglePrompt(false);
    };

    const onClickCancel = () => {
      this.props.togglePrompt(false);
    };

    const onClickConfirm = () => {
      this.props.deletePlatform(this.platform.id);
      this.props.togglePrompt(false);
    };

    return (
      <ConfirmDialog
        show={this.props.common.togglePrompt}
        modalTitle={modalTitle}
        modalBody={modalBody}
        onHideFunction={onHideFunction}
        onClickCancel={onClickCancel}
        onClickConfirm={onClickConfirm}
      />
    );
  };

  render() {
    const addPlatform = (
      <Button
        id="add-platform"
        size="sm"
        onClick={() => {
          this.props.history.push("/settings/platforms/add");
        }}
      >
        Add Group
      </Button>
    );

    let listPagination = "";

    if (!this.props.platforms.platformFilter) {
      listPagination = (
        <div className="float-right mt-3">
          <ListPagination
            dispatchType={SET_PLATFORMS_PAGINATION}
            data={this.props.platforms.platforms}
            min={this.props.platforms.min}
            max={this.props.platforms.max}
            currentPage={this.props.platforms.currentPage}
            totalPages={this.props.platforms.totalPages}
            fetchCallback=""
            numItems={this.props.platforms.numItems}
          />
        </div>
      );
    }

    return (
      <>
        {this.promptModal()}
        <PageTitle pageName="Groups" actionButton={addPlatform} />
        <Row>
          <Col>{listPagination}</Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Table>
              <thead>
                <tr>
                  <th className="align-center">
                    Group
                  </th>
                  <th className="align-center">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                <td colSpan={2}>{this.filterPlatforms()}</td>
                {this.renderPlatforms()}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col>{listPagination}</Col>
        </Row>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  common: state.common,
  platforms: state.platforms,
});

const mapDispatchToProps = (dispatch) => ({
  fetchPlatforms: () => dispatch(fetchPlatforms()),
  deletePlatform: (...args) => dispatch(deletePlatform(...args)),
  togglePrompt: (...args) => dispatch(togglePrompt(...args)),
  filterPlatforms: (...args) => dispatch(filterPlatforms(...args)),
  resetPagination: (...args) => dispatch(resetPagination(...args)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Platforms)
);
